import { render, staticRenderFns } from "./SurveyDetail.vue?vue&type=template&id=88b73b02&scoped=true&"
import script from "./SurveyDetail.vue?vue&type=script&lang=js&"
export * from "./SurveyDetail.vue?vue&type=script&lang=js&"
import style0 from "./SurveyDetail.vue?vue&type=style&index=0&id=88b73b02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b73b02",
  null
  
)

export default component.exports